import React from 'react'
import { PopupButton } from '@typeform/embed-react'
import { Box, Image } from 'theme-ui'

const ClueImage = ({ formId, width }) => {
  return (
    <PopupButton
      id={formId || 'dImjDByp'}
      size={100}
      style={{
        backgroundColor: 'none',
        border: 'none',
        background: 'none',
        padding: 0,
        cursor: 'pointer',
        zIndex: 0,
        marginRight: width >= 1024 ? '12rem' : '0',
        marginBottom: width >= 1024 ? '20rem' : '10rem',
      }}
    >
      <Box
        sx={{
          display: 'inline-block',
          '&:hover': {
            '.clue-default': { display: ['none', 'none', 'none'] },
            '.clue-hover': { display: ['none', 'none', 'block'] },
          },
        }}
      >
        <Image
          src="/images/clubhouse/hero/clue_mobile_texture.png"
          alt="Clue"
          className="clue"
          sx={{
            height: '100%',
            width: ['90%', '100%', '100%'],
            maxWidth: ['400px', '400px', '800px'],
            pointerEvents: 'none',
            mx: ['auto', 'auto', '0'],
            display: ['block', 'block', 'none'],
          }}
        />
        <Image
          src="/images/clubhouse/hero/clue_desktop_texture.png"
          alt="Clue"
          className="clue-default"
          sx={{
            height: '100%',
            width: [null, null, '100%'],
            maxWidth: [null, null, '800px'],
            pointerEvents: 'none',
            mx: ['auto', 'auto', '0'],
            display: ['none', 'none', 'block'],
          }}
        />
        <Image
          src="/images/clubhouse/hero/clue_desktop_texture_hover.png"
          className="clue-hover"
          alt="Clue"
          sx={{
            display: 'none',
            height: '100%',
            width: '100%',
            maxWidth: '800px',
            maxHeight: '500px',
            mx: '0',
          }}
        />
      </Box>
    </PopupButton>
  )
}

export default ClueImage
